// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tool-tip-container .md-button.terms{text-transform:none}.tool-tip-container .md-button.terms:before{opacity:0}.tool-tip-container .md-button.terms:hover span{color:#2c6eff}\n", ""]);
// Exports
module.exports = exports;
